<template>
  <div class="index-article">
    <div class="container-md">
      <div class="article-title">签证知识</div>
      <div class="article-content">
        <div class="article-nav-list">
          <div class="article-nav-item" @click="gotoNav($event, item)" v-for="(item, index) in navList" :key="index">
            <img class="icon" :src="item.icon">
            <div class="right-box">
              <div class="text">{{item.name}}</div>
              <div class="desc">{{item.desc}}</div>
            </div>
          </div>
        </div>
        <div class="article-info-box">
          <div class="article-info-left">
            <div class="label">推荐</div>
            <div class="article-recommend-list">
              <div class="article-recommend-item" v-for="item in recommendArticle" :key="item.id">
                <img class="item-img" :src="item.cover" />
                <router-link :to="{name: 'article', params: {id: item.id}}" class="item-content">
                  <div class="item-content-title">{{item.title}}</div>
                  <div class="item-content-desc">{{item.summary}}</div>
                  <div class="item-content-time">{{item.update_time}}</div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="article-info-right">
            <div class="label">最热</div>
            <div class="content">
              <div class="article-hot-list">
                <router-link :to="{name: 'article', params: {id: item.id}}" class="article-hot-item" v-for="(item, index) in hotArticle" :key="index">
                  <img class="icon" v-if="index < 3" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-hot.png" alt="">
                  <div class="text">{{item.title}}</div>
                </router-link>
              </div>
              <div class="article-video-box">
                <div class="video-play-btn" @click="fullScreen"></div>
                <video id="article-video" src="https://o.666visa.cn/video/ssq2020-2-28.mp4" :controls="true" :muted="isIE()" height="100%" width="100%"></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'index-article',
  props: {
    hotArticle: {
      type: Array,
      default() {
        return [];
      },
    },
    recommendArticle: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      navList: [
        {
          name: '最新资讯',
          desc: '最新使馆签证政策',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/nav_message.png',
          route: { name: 'latestNews' },
        },
        {
          name: '案例解析',
          desc: '深度解析签证专题',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/nav_special.png',
          route: { name: 'caseAnalysis' },
        },
        {
          name: '签证公开课',
          desc: '签证知识大讲堂',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/nav_visa.png',
          route: { name: 'visaOpenClass' },
        },
        {
          name: '办签指南',
          desc: '产品使用详细说明',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/nav_guide.png',
          route: { name: 'visaGuide' },
        },
      ],
      videoFullScreen: false,
    };
  },
  mounted() {
    this.initVideo();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true; }
      return false;
    },
    gotoNav(e, item) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push(item.route);
    },
    initVideo() {
      window.addEventListener('resize', this.handleResize);
    },
    handleResize() {
      const isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
      if (!isFull) {
        this.pauseVideo();
        this.videoFullScreen = false;
      }
    },
    pauseVideo() {
      const videoEl = document.querySelector('#article-video');
      videoEl && videoEl.pause();
    },
    // 进入全屏
    fullScreen(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      const videoEl = document.querySelector('#article-video');
      videoEl.currentTime = 0;
      try {
        videoEl.play();
      } catch (error) {
        console.log(error);
      }

      const ua = window.navigator.userAgent;
      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        setTimeout(() => {
          if (videoEl.requestFullscreen) {
            videoEl.requestFullscreen();
          } else if (videoEl.mozRequestFullScreen) {
            videoEl.mozRequestFullScreen();
          } else if (videoEl.webkitRequestFullScreen) {
            videoEl.webkitRequestFullScreen();
          } else if (videoEl.msRequestFullscreen) {
            videoEl.msRequestFullscreen();
          }
        }, 0);
      } else {
        if (videoEl.requestFullscreen) {
          videoEl.requestFullscreen();
        } else if (videoEl.mozRequestFullScreen) {
          videoEl.mozRequestFullScreen();
        } else if (videoEl.webkitRequestFullScreen) {
          videoEl.webkitRequestFullScreen();
        } else if (videoEl.msRequestFullscreen) {
          videoEl.msRequestFullscreen();
        }
      }

      this.videoFullScreen = true;
    },
  },
};
</script>
<style lang="less" scoped>
.index-article{
  padding: 48px 0;
  background: #fff url(https://o.666visa.cn/static/ssqpeer/homepage/article-bg.png) no-repeat center top;
  .article-title{
    text-align: center;
    color: #2F333D;
    font-size: 32px;
    line-height: 1;
    font-weight: 500;
    position: relative;
    z-index: 1;
    margin-bottom: 36px;
    &::after{
      content: "";
      width:80px;
      height:8px;
      background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      opacity:0.8;
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%);
      z-index: -1;
    }
  }
  .article-content{
    .article-nav-list{
      width: 100%;
      height: 80px;
      border-radius:1px;
      box-shadow:0px 4px 6px 0px rgba(47,51,61,0.06);
      background: #fff;
      padding: 0 10px;
      display: flex;
      margin-bottom: 16px;
      .article-nav-item{
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease-out;
        &:hover{
          transform: translateY(-2px);
          .text{
            color: #599FFF;
          }
        }
        &::after{
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width:1px;
          height:32px;
          background: #E9EEF2;
          border-radius:1px;
        }
        &:last-child{
          &::after{
            display: none;
          }
        }
        .icon{
          width: 42px;
          height: 42px;
          margin-right: 16px;
        }
        .right-box {
          .text{
            font-size: 16px;
            font-weight: 600;
            color: #2F333D;
            line-height: 16px;
          }
          .desc {
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            color: #5F666E;
            line-height: 17px;
          }
        }
      }
    }

    .article-info-box{
      box-shadow:0px 4px 6px 0px rgba(47,51,61,0.06);
      background: #fff;
      border-radius:1px;
      padding: 16px 32px 32px 32px;
      display: flex;
      .article-info-left{
        flex-grow: 1;
        overflow: hidden;
        .label{
          font-size: 20px;
          color: #2F333D;
          line-height: 28px;
          margin-bottom: 12px;
          font-weight: 600;
        }
        .article-recommend-list{
          .article-recommend-item{
            cursor: pointer;
            display: flex;
            padding: 16px 0;
            border-bottom: 1px solid #E9EEF2;
            transition: all 0.2s;
            &:hover{
              background: rgba(243,246,249,0.5);
              .item-content-title{
                color: #599FFF !important;
              }
            }
            &:last-child{
              border-bottom: none;
            }
            .item-img{
              width: 150px;
              height: 100px;
              flex-shrink: 0;
              margin-right: 16px;
            }
            .item-content{
              flex-grow: 1;
              overflow: hidden;
              .item-content-title{
                font-size: 18px;
                line-height: 24px;
                margin-bottom: 12px;
                color: #2F333D;
                font-weight: 600;
                margin-top: 4px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .item-content-desc{
                font-size: 14px;
                line-height: 20px;
                color: #5F666E;
                margin-bottom: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .item-content-time{
                color: #C9CDD1;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
        }
      }
      .article-info-right{
        flex-shrink: 0;
        width: 300px;
        margin-left: 24px;
        .label{
          font-size: 20px;
          color: #2F333D;
          line-height: 28px;
          margin-bottom: 12px;
          font-weight: 600;
        }
        .content{
          .article-hot-list{
            margin-bottom: 30px;
            .article-hot-item{
              display: flex;
              align-items: center;
              margin-bottom: 20px;
              cursor: pointer;
              &:hover{
                .text{
                  color: #599FFF;
                }
              }
              .icon{
                width: 16px;
                height: 16px;
                flex-shrink: 0;
                margin-right: 4px;
              }
              .text{
                flex-grow: 1;
                font-size: 16px;
                line-height: 22px;
                color: #2F333D;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
          }
          .article-video-box{
            width: 100%;
            height: 170px;
            position: relative;
            cursor: pointer;
            .video-play-btn{
              position: absolute;
              left: 0;
              top: 0;
              z-index: 10;
              width: 100%;
              height: 100%;
              background: url(https://o.666visa.cn/static/ssqpeer/homepage/video-bg.png) no-repeat center center;
              background-size: 100% 100%;
              &::after{
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: url(https://o.666visa.cn/static/ssqpeer/homepage/icon-play.png) no-repeat center center;
                background-size: 72px 72px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index-article.vue